<style lang="postcss">
  @keyframes move_wave {
    0% {
        transform: translateX(0) translateZ(0) scaleY(1)
    }
    50% {
        transform: translateX(-25%) translateZ(0) scaleY(0.55)
    }
    100% {
        transform: translateX(-50%) translateZ(0) scaleY(1)
    }
  }
  .waveWrapper {
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }
  .waveWrapperInner {
    position: absolute;
    width: 100%;
    overflow: hidden;
    height: 100%;
    bottom: -1px;
  }
  .bgTop {
    z-index: 15;
    opacity: 0.5;
  }
  .bgMiddle {
    z-index: 10;
    opacity: 0.75;
  }

  .bgBottom {
    z-index: 5;
  }
  .wave {
    position: absolute;
    left: 0;
    width: 200%;
    height: 100%;
    background-repeat: repeat no-repeat;
    background-position: 0 bottom;
    transform-origin: center bottom;
  }
  .waveTop {
    background-size: 50% 100px;
  }
  .waveAnimation .waveTop {
    animation: move-wave 3s;
      -webkit-animation: move-wave 3s;
      -webkit-animation-delay: 1s;
      animation-delay: 1s;
  }
  .waveMiddle {
    background-size: 50% 120px;
  }
  .waveAnimation .waveMiddle {
    animation: move_wave 10s linear infinite;
  }
  .waveBottom {
    background-size: 50% 100px;
  }
  .waveAnimation .waveBottom {
    animation: move_wave 15s linear infinite;
  }

  /*------- Activate - Deactivate Waves -------*/ 

  :global(.waveDeactivatedIndex) {
    transform: translateY(80%);
  }

  :global(.waveDeactivated) {
    animation: deactivateWave 8s linear forwards;
    animation-iteration-count: 1;
  }

  :global(.waveActivated) {
    animation: activateWave 1s linear forwards;
    animation-iteration-count: 1;
  }

  @keyframes activateWave {
    0% {
      transform: translateY(var(--waveY));
    }
    100% {
      transform: translateY(0%);
    }
  }

  @keyframes deactivateWave {
    0% {
      transform: translateY(var(--waveY));
    }
    100% {
      transform: translateY(80%);
    }
  }
</style>

<div id='waves' class="navbar text-white py-20 text-center fixed left-0 bottom-0 right-0 z-40 waveDeactivatedIndex">
  <div class="waveWrapper waveAnimation">
     <div class="waveWrapperInner bgTop">
        <div class="wave waveTop" style="background-image: url('./first_wave.png')"></div>
     </div>
     <div class="waveWrapperInner bgMiddle">
        <div class="wave waveMiddle" style="background-image: url('./third_wave.png')"></div>
     </div>
     <div class="waveWrapperInner bgBottom">
        <div class="wave waveBottom" style="background-image: url('./third_wave.png')"></div>
     </div>
  </div>
</div>

<script>
  import {location} from 'svelte-spa-router'
  import { connected } from './../stores.js';
  import { onMount } from 'svelte';

  $: ($location == '/Index' || $location == '/') && hideWaves();
  $: $location  != '/Index' && $location != '/'  && $connected && showWaves();

  onMount(async () => {
    $location  != '/Index' && $location != '/'  && $connected && showWaves();
  });

  $: (console.log('log', pageRefreshed()));

  function pageRefreshed() {
    return (window.performance.navigation && window.performance.navigation.type === 1) ||
    window.performance
      .getEntriesByType('navigation')
      .map((nav) => nav.type)
      .includes('reload');
  }

  function getTranslateValues(element) {
    const style = window.getComputedStyle(element)
    const matrix = style['transform'] || style.webkitTransform || style.mozTransform

    // No transform property. Simply return 0 values.
    if (matrix === 'none' || typeof matrix === 'undefined') {
      return {
        x: 0,
        y: 0,
        z: 0
      }
    }

    // Can either be 2d or 3d transform
    const matrixType = matrix.includes('3d') ? '3d' : '2d'
    const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ')

    // 2d matrices have 6 values
    // Last 2 values are X and Y.
    // 2d matrices does not have Z value.
    if (matrixType === '2d') {
      return {
        x: matrixValues[4],
        y: matrixValues[5],
        z: 0
      }
    }

    // 3d matrices have 16 values
    // The 13th, 14th, and 15th values are X, Y, and Z
    if (matrixType === '3d') {
      return {
        x: matrixValues[12],
        y: matrixValues[13],
        z: matrixValues[14]
      }
    }
  }


  function hideWaves() {
    if (document.getElementById('waves')) {
      var {x, y, z} = getTranslateValues(document.getElementById('waves'));
      document.getElementById('waves').style.setProperty('--waveY', y +'px')

      document.getElementById('waves').classList.remove('waveActivated');
      document.getElementById('waves').classList.add('waveDeactivated');
    }
  }

  function showWaves() {
    if (document.getElementById('waves')) {
      var {x, y, z} = getTranslateValues(document.getElementById('waves'));
      document.getElementById('waves').style.setProperty('--waveY', y +'px')

      document.getElementById('waves').classList.remove('waveDeactivated');
      document.getElementById('waves').classList.add('waveActivated');
    }
  }
</script>